import {Injectable} from '@angular/core';
import {DcpIndustryModel} from '../homepage/browse-industry/dcp-industry.model';
import {JsonService} from '@dcp/configurator';
import {RoutingService} from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})

export class IndustryService {

  industries: Array<DcpIndustryModel> = [
    {name: 'Professional Services'},
    {name: 'Consumer Products'},
    {name: 'Retail'},
    {name: 'Chemicals'},
    {name: 'Wholesale Distribution'},
    {name: 'Automotive'},
    {name: 'View All', route: 'search'}
  ];

  constructor(
    private jsonService: JsonService,
    private routingService: RoutingService
  ) {
  }

  getIndustries(): Array<DcpIndustryModel> {
    // Returning a deep copy so the changes on the industries don't influence other components
    return this.jsonService.parseSafely(JSON.stringify(this.industries));
  }

  displayProductsOfIndustry(industry: DcpIndustryModel): void {
    const queryTerm: string = (industry.route) ? '' : (':industries:' + industry.name);
    this.routingService.go({
        cxRoute: 'search',
        params: {
          query: '',
        },
      },
      {
        queryParams: {
          query: ':name-asc' + queryTerm,
        }
      });
  }
}
